"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchHistoryStore = matchHistoryStore;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const isTypedObservationHistoryStore = (hs) => {
    return hs.hasKey('fromTimestampMs') && hs.hasKey('toTimestampMs');
};
function matchHistoryStore(input) {
    if (!isTypedObservationHistoryStore(this)) {
        throw new Error(`HistoryStore does not have required keys for matching: ${this?.keys().join(', ') ?? 'none'}. Required keys are 'fromTimestampMs' and 'toTimestampMs'`);
    }
    if (!this.isTimeOrdered(iotv_v3_types_1.SortOrder.ASCENDING)) {
        throw new Error('HistoryStore is not in ascending order, this function assumes ascending order for matching');
    }
    const { readings, key } = input;
    const sumArray = this.addKey(`${key}_sum`);
    const countArry = this.addKey(`${key}_count`);
    const fromTimestamps = this.fromTimestampMs;
    const toTimestamps = this.toTimestampMs;
    const findFirstTimestampIdx = (timestamp) => fromTimestamps.findLastIndex((fromT, i) => (0, iotv_v3_types_1.isNonNaNNumber)(fromT) && fromT <= timestamp);
    const findLastTimestampIdx = (timestamp) => toTimestamps.findIndex((toT, i) => (0, iotv_v3_types_1.isNonNaNNumber)(toT) && toT > timestamp);
    readings.forEach(({ timestamp, value }, i) => {
        const prevReading = readings[i - 1];
        const nextReading = readings[i + 1];
        const bucketStartTimestamp = ((prevReading?.timestamp ?? timestamp) + timestamp) / 2;
        const bucketEndTimestamp = ((nextReading?.timestamp ?? timestamp) + timestamp) / 2;
        const firstTimestampIdx = findFirstTimestampIdx(bucketStartTimestamp);
        const lastTimestampIdx = findLastTimestampIdx(bucketEndTimestamp);
        const firstStateSnapshot = this.getStateSnapshotAt(firstTimestampIdx);
        const lastStateSnapshot = this.getStateSnapshotAt(lastTimestampIdx);
        if (firstStateSnapshot && lastStateSnapshot) {
            const { fromTimestampMs: from1, toTimestampMs: to1 } = firstStateSnapshot.state;
            const { fromTimestampMs: from2, toTimestampMs: to2 } = lastStateSnapshot.state;
            const totalDuration = to2 - from1;
            console.log(`Found state snapshots for reading at timestamp ${timestamp}, first snapshot from ${from1} to ${to1}, last snapshot from ${from2} to ${to2}, totalDuration: ${totalDuration}`);
            for (let i = firstTimestampIdx; i <= lastTimestampIdx; i++) {
                const stateSnapshot = this.getStateSnapshotAt(i);
                if (stateSnapshot) {
                    const { fromTimestampMs, toTimestampMs } = stateSnapshot.state;
                    const overlapDuration = Math.max(0, Math.min(toTimestampMs, to2) - Math.max(fromTimestampMs, from1));
                    const proportion = (overlapDuration / totalDuration);
                    const valuePortion = totalDuration > 0 ? value * proportion : 0;
                    sumArray[i] = (sumArray[i] ?? 0) + valuePortion;
                    countArry[i] = (countArry[i] ?? 0) + proportion;
                    console.log(`Matching reading at timestamp ${timestamp} with state snapshot at index ${i}, from: ${fromTimestampMs}, to: ${toTimestampMs}, valuePortion: ${valuePortion}, proportion: ${proportion}`);
                }
                else {
                    console.warn(`No state snapshot at index ${i} for timestamp ${this.timestamp[i]}`);
                }
            }
        }
        else {
            console.warn(`Could not find state snapshots for timestamp ${timestamp}, firstTimestampIdx: ${firstTimestampIdx}, lastTimestampIdx: ${lastTimestampIdx}`);
        }
    });
    return this;
}
